export const videoList = [
  {
    id: "video-1",
    title: "《星河彼岸》官方MV 首播：一场关于远行与归来的浪漫",
    category: "影视MV",
    cover:
      "https://readdy.ai/api/search-image?query=dreamy%20music%20video%20scene%20with%20a%20singer%20silhouette%20under%20a%20starry%20sky%20and%20reflective%20water%2C%20deep%20blue%20and%20warm%20orange%20gradient%2C%20cinematic%20romantic%20mood%2C%20highly%20detailed&width=800&height=450&seq=video-mv-starriver-01&orientation=landscape",
    duration: "04:32",
    views: "128.6万",
    author: "天天音乐现场",
    date: "2026-10-14",
    description:
      "全新单曲《星河彼岸》官方MV正式上线。这次拍摄远赴海边与戈壁取景，用光影讲述了关于远行与归来的故事，副歌部分的和声处理相当惊艳。",
    episodes: [
      { id: "ep-1", title: "MV 正片", duration: "04:32" },
      { id: "ep-2", title: "幕后花絮：戈壁拍摄日记", duration: "06:18" },
      { id: "ep-3", title: "创作谈：这首歌是怎么写出来的", duration: "08:45" },
    ],
  },
  {
    id: "video-2",
    title: "爆款综艺名场面合集：笑到停不下来的十个瞬间",
    category: "综艺片段",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20colorful%20variety%20show%20stage%20with%20confetti%20and%20laughing%20people%2C%20playful%20energetic%20atmosphere%2C%20vibrant%20orange%20and%20yellow%20tones%2C%20television%20production%20style&width=800&height=450&seq=video-variety-funny-02&orientation=landscape",
    duration: "12:05",
    views: "356.2万",
    author: "综艺剪辑室",
    date: "2026-10-13",
    description:
      "精选本季最搞笑的十个名场面，从游戏翻车到嘉宾神级反应，一次看过瘾。如果你还没跟上这部综艺，从这个合集入坑刚刚好。",
    episodes: [
      { id: "ep-1", title: "上集：游戏环节爆笑合集", duration: "06:02" },
      { id: "ep-2", title: "下集：嘉宾临场反应合集", duration: "06:03" },
    ],
  },
  {
    id: "video-3",
    title: "开放世界新游实机攻略：开局两小时快速上手",
    category: "游戏视频",
    cover:
      "https://readdy.ai/api/search-image?query=third%20person%20view%20of%20a%20fantasy%20game%20hero%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20world%2C%20epic%20sunset%20lighting%2C%20game%20UI%20elements%2C%20high%20detail&width=800&height=450&seq=video-game-guide-03&orientation=landscape",
    duration: "18:40",
    views: "92.4万",
    author: "攻略速递",
    date: "2026-10-12",
    description:
      "本期视频带你走过开放世界新游的开局两小时，从初始职业选择、资源采集路线到第一个主线Boss的打法，全部拆解清楚，新手也能轻松上手。",
    episodes: [
      { id: "ep-1", title: "职业选择与初始加点", duration: "06:10" },
      { id: "ep-2", title: "资源采集与装备强化", duration: "06:20" },
      { id: "ep-3", title: "第一个Boss无伤打法", duration: "06:10" },
    ],
  },
  {
    id: "video-4",
    title: "摇滚乐队新单曲现场版：全场大合唱的震撼时刻",
    category: "影视MV",
    cover:
      "https://readdy.ai/api/search-image?query=rock%20band%20live%20on%20stage%20with%20dramatic%20red%20and%20orange%20spotlights%2C%20electric%20guitar%20silhouette%2C%20energetic%20crowd%2C%20powerful%20concert%20atmosphere%2C%20cinematic&width=800&height=450&seq=video-rock-live-04&orientation=landscape",
    duration: "05:48",
    views: "204.1万",
    author: "现场记录者",
    date: "2026-10-11",
    description:
      "乐队巡演收官站的现场实录，新单曲首次完整呈现，副歌部分全场观众自发大合唱的画面让人热血沸腾。收音质量非常出色，值得戴耳机欣赏。",
    episodes: [
      { id: "ep-1", title: "新单曲现场版", duration: "05:48" },
      { id: "ep-2", title: "安可曲目返场", duration: "09:12" },
    ],
  },
  {
    id: "video-5",
    title: "音乐竞演高光合集：那些让人起鸡皮疙瘩的改编",
    category: "综艺片段",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20music%20competition%20stage%20with%20soft%20spotlight%20and%20orchestra%20silhouettes%2C%20warm%20amber%20and%20gold%20lighting%2C%20emotional%20performance%20atmosphere%2C%20cinematic&width=800&height=450&seq=video-music-highlight-05&orientation=landscape",
    duration: "15:22",
    views: "178.9万",
    author: "综艺剪辑室",
    date: "2026-10-10",
    description:
      "整理了本季音乐竞演中最令人难忘的改编舞台。每一位歌手都在原曲基础上做出了大胆的尝试，其中几段跨界融合的处理堪称神来之笔。",
    episodes: [
      { id: "ep-1", title: "第一部分：抒情改编", duration: "07:40" },
      { id: "ep-2", title: "第二部分：摇滚与跨界", duration: "07:42" },
    ],
  },
  {
    id: "video-6",
    title: "竞技游戏新赛季阵容解析：版本强势组合一网打尽",
    category: "游戏视频",
    cover:
      "https://readdy.ai/api/search-image?query=esports%20arena%20with%20huge%20screens%20and%20blue%20and%20orange%20lighting%2C%20competitive%20gaming%20atmosphere%2C%20stadium%20crowd%20silhouettes%2C%20high%20detail%20digital%20art&width=800&height=450&seq=video-esports-meta-06&orientation=landscape",
    duration: "22:15",
    views: "143.7万",
    author: "电竞战术板",
    date: "2026-10-09",
    description:
      "新赛季改动不小，本期视频从英雄强度、装备调整到阵容搭配，系统地梳理了当前版本的强势组合，并给出了不同分段的应对思路。",
    episodes: [
      { id: "ep-1", title: "版本改动总览", duration: "07:05" },
      { id: "ep-2", title: "强势阵容推荐", duration: "07:35" },
      { id: "ep-3", title: "分段上分思路", duration: "07:35" },
    ],
  },
  {
    id: "video-7",
    title: "治愈系民谣MV：一把木吉他的温柔独白",
    category: "影视MV",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20acoustic%20folk%20music%20video%20with%20a%20guitar%20by%20a%20sunlit%20window%20and%20dried%20flowers%2C%20soft%20natural%20light%2C%20warm%20beige%20tones%2C%20peaceful%20minimal%20aesthetic&width=800&height=450&seq=video-folk-mv-07&orientation=landscape",
    duration: "03:56",
    views: "76.3万",
    author: "天天音乐现场",
    date: "2026-10-08",
    description:
      "一首适合在午后单曲循环的治愈民谣。MV采用极简的室内拍摄，木吉他的编排干净温暖，非常贴合歌词中那种淡淡的思念情绪。",
    episodes: [
      { id: "ep-1", title: "MV 正片", duration: "03:56" },
      { id: "ep-2", title: "纯音乐伴奏版", duration: "03:56" },
    ],
  },
  {
    id: "video-8",
    title: "户外真人秀爆笑片段：全员翻车的露营之夜",
    category: "综艺片段",
    cover:
      "https://readdy.ai/api/search-image?query=night%20camping%20scene%20with%20colorful%20tents%20and%20warm%20campfire%2C%20stars%20in%20the%20sky%2C%20cozy%20outdoor%20adventure%20atmosphere%2C%20soft%20orange%20light%2C%20cinematic&width=800&height=450&seq=video-camping-fail-08&orientation=landscape",
    duration: "10:34",
    views: "221.8万",
    author: "综艺剪辑室",
    date: "2026-10-07",
    description:
      "本季最经典的露营之夜片段来了。从搭帐篷到生火做饭，六位嘉宾几乎每一个环节都在翻车，但正是这种手忙脚乱让观众笑到肚子疼。",
    episodes: [
      { id: "ep-1", title: "搭帐篷大作战", duration: "05:12" },
      { id: "ep-2", title: "黑暗料理之夜", duration: "05:22" },
    ],
  },
];